"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const BaseButton_1 = __importDefault(require("./BaseButton"));
const StyledLoader_1 = __importDefault(require("./StyledLoader"));
const Button = ({ children, disabled = false, left, loading = false, right, ...buttonProps }, ref) => {
    return ((0, jsx_runtime_1.jsxs)(BaseButton_1.default, { disabled: disabled || loading, ...buttonProps, ref: ref, children: [left &&
                react_1.default.cloneElement(left, {
                    style: {
                        marginRight: '8px'
                    }
                }), loading ? ((0, jsx_runtime_1.jsx)(StyledLoader_1.default, { color: '#fff', loading: true, speedMultiplier: 0.5, size: '0.5em' })) : (children), right &&
                react_1.default.cloneElement(right, {
                    style: {
                        marginLeft: '8px',
                        fontSize: '22px'
                    }
                })] }));
};
exports.default = react_1.default.memo(react_1.default.forwardRef(Button));
//# sourceMappingURL=Button.js.map